/* pp-sticky.js: on phones, pins the wallet preview to the top of the screen while the options are being chosen.
   It pins once the preview starts to scroll off the top, and lets go once the Add to Cart button has scrolled past.
   Look and size: the "Phones" block in wallet-preview.css. */
(function () {
  'use strict';
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function init() {
    var root = document.querySelector('[data-pp-preview]');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!root || !form || root.__ppSticky) return;
    root.__ppSticky = true;
    var spacer = document.createElement('div'); /* keeps the page from jumping when the preview leaves its spot */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp-pin-toggle';
    btn.textContent = 'Hide';
    root.appendChild(btn);
    var pinned = false, mini = false, ticking = false;
    btn.addEventListener('click', function () {
      mini = !mini;
      root.classList.toggle('pp-preview--mini', mini);
      btn.textContent = mini ? 'Show preview' : 'Hide';
    });
    function pin(on) {
      if (on === pinned) return;
      pinned = on;
      if (on) {
        spacer.style.height = root.offsetHeight + 'px';
        root.parentNode.insertBefore(spacer, root);
        root.classList.add('pp-preview--pinned');
      } else {
        root.classList.remove('pp-preview--pinned');
        if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
      }
    }
    function update() {
      ticking = false;
      if (!mq || !mq.matches) { pin(false); return; }
      var start = (pinned ? spacer : root).getBoundingClientRect().top;
      var end = form.getBoundingClientRect().bottom;
      pin(start < 0 && end > root.offsetHeight + 40);
    }
    var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
